import { render } from "./StoryBankCompleted.vue?vue&type=template&id=598af7ce&scoped=true"
import script from "./StoryBankCompleted.vue?vue&type=script&lang=js"
export * from "./StoryBankCompleted.vue?vue&type=script&lang=js"

import "./StoryBankCompleted.vue?vue&type=style&index=0&id=598af7ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-598af7ce"]])

export default __exports__